import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import { Box, IconButton, InputAdornment, TextField } from "@mui/material";

import { useRoleContext } from "hooks/useRoleContext";

interface ChatInboxSearchProps {
  value: string;
  onChange: (value: string) => void;
}

export function ChatInboxSearch(props: ChatInboxSearchProps) {
  const { value, onChange } = props;
  const { role } = useRoleContext();
  const counterpartyLabel = role?.type === "CARRIER" ? "shipper" : "carrier";

  return (
    <Box
      sx={{
        px: 2,
        py: 1.5,
        borderBottom: 1,
        borderColor: "divider",
      }}
    >
      <TextField
        fullWidth
        size="small"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={`Search by shipment or ${counterpartyLabel}…`}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" sx={{ color: "text.secondary" }} />
            </InputAdornment>
          ),
          endAdornment:
            value.length > 0 ? (
              <InputAdornment position="end">
                <IconButton
                  size="small"
                  aria-label="Clear search"
                  onClick={() => onChange("")}
                >
                  <ClearIcon fontSize="small" />
                </IconButton>
              </InputAdornment>
            ) : null,
        }}
      />
    </Box>
  );
}
